import { t } from "@/i18n-js/instance";
import { ModalCloseButton } from "@circle-react-shared/ModalsV2/FullScreenModal/components/ModalCloseButton";
import { Button } from "@circle-react-uikit/Button";
import { SelectRadioGroup } from "@circle-react-uikit/SelectRadioGroup";
import { Tab } from "@circle-react-uikit/TabV2";
import { Typography } from "@circle-react-uikit/Typography";
import { formId, i18nRoot } from "./constants";
import type { ModalTab } from "./types";

interface ModalTabOption {
  label: string;
  value: ModalTab;
}

interface ModalHeaderProps {
  isSubmitDisabled: boolean;
  onClose: () => void;
  selectedTab: ModalTab;
  setSelectedTab: (tab: ModalTab) => void;
}

export const ModalHeader = ({
  isSubmitDisabled,
  onClose,
  selectedTab,
  setSelectedTab,
}: ModalHeaderProps) => {
  const tabOptions: ModalTabOption[] = [
    {
      label: t(`${i18nRoot}.modal.tabs.edit`),
      value: "edit",
    },
    {
      label: t(`${i18nRoot}.modal.tabs.analytics`),
      value: "analytics",
    },
  ];

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex">
        <div className="flex w-2/3 items-center md:w-1/3">
          <Typography.TitleSm weight="semibold" color="text-darkest">
            {t(`${i18nRoot}.modal.title`)}
          </Typography.TitleSm>
        </div>
        <div className="hidden w-1/3 items-center justify-center md:flex">
          <SelectRadioGroup
            value={selectedTab}
            onChange={tab => setSelectedTab(tab)}
            options={tabOptions}
          />
        </div>
        {selectedTab === "edit" && (
          <div className="hidden w-1/3 items-center justify-end md:flex">
            <Button
              type="submit"
              form={formId}
              variant="circle"
              disabled={isSubmitDisabled}
            >
              {t("save")}
            </Button>
          </div>
        )}
        <div className="flex w-1/3 items-center justify-end md:hidden">
          <ModalCloseButton onClick={onClose} />
        </div>
      </div>
      <div className="flex flex-col md:hidden">
        <Tab.Group
          selectedIndex={tabOptions.findIndex(tab => tab.value === selectedTab)}
          onChange={tabIndex => setSelectedTab(tabOptions[tabIndex].value)}
        >
          <Tab.List>
            {tabOptions.map(tab => (
              <Tab key={tab.value}>{tab.label}</Tab>
            ))}
          </Tab.List>
        </Tab.Group>
      </div>
    </div>
  );
};
